// Product Card Carousel for PRESTIGE - WITH API IMAGE LOADING
// Carga TODAS las imágenes del producto desde la API de Shopify

(function() {
  'use strict';
  
  function initCarousel() {
    const cards = document.querySelectorAll('.product-card');
    
    cards.forEach(function(card) {
      const wrapper = card.querySelector('a') || card.querySelector('figure');
      if (!wrapper) return;
      
      // Obtener URL del producto desde el link
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;
      
      const productUrl = productLink.href;
      const productHandle = productUrl.split('/products/')[1].split('?')[0];
      
      // Cargar datos del producto desde la API
      fetch('/products/' + productHandle + '.js')
        .then(response => response.json())
        .then(function(product) {
          if (product.images.length <= 1) return;
          
          // Precargar todas las imágenes primero
          const imagePromises = product.images.map(function(imageUrl) {
            return new Promise(function(resolve) {
              const img = new Image();
              img.onload = function() { resolve(img); };
              img.onerror = function() { resolve(null); };
              img.src = imageUrl;
            });
          });
          
          // Cuando todas estén cargadas, configurar el carrusel
          Promise.all(imagePromises).then(function(loadedImages) {
            const validImages = loadedImages.filter(img => img !== null);
            if (validImages.length > 1) {
              setupCarousel(card, wrapper, product.images);
            }
          });
        })
        .catch(function(error) {
          console.error('Error cargando producto:', error);
        });
    });
  }
  
  function setupCarousel(card, wrapper, imageUrls) {
    wrapper.style.position = 'relative';
    
    let currentIndex = 0;
    let images = [];
    
    // Crear contenedor para imágenes
    const imageContainer = document.createElement('div');
    imageContainer.style.position = 'relative';
    imageContainer.style.width = '100%';
    
    // Crear elementos img para cada URL
    imageUrls.forEach(function(imageUrl, i) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = '';
      img.loading = 'lazy';
      
      img.style.width = '100%';
      img.style.height = 'auto';
      img.style.objectFit = 'cover';
      
      if (i === 0) {
        img.style.position = 'relative';
        img.style.setProperty('opacity', '1', 'important');
        img.style.setProperty('visibility', 'visible', 'important');
        img.style.setProperty('z-index', '2', 'important');
      } else {
        img.style.position = 'absolute';
        img.style.top = '0';
        img.style.left = '0';
        img.style.setProperty('opacity', '0', 'important');
        img.style.setProperty('visibility', 'hidden', 'important');
        img.style.setProperty('z-index', '1', 'important');
      }
      
      imageContainer.appendChild(img);
      images.push(img);
    });
    
    // Reemplazar imágenes existentes con el nuevo contenedor
    const existingImages = wrapper.querySelectorAll('img');
    
    // Fade out rápido de las imágenes existentes
    existingImages.forEach(function(img) {
      img.style.transition = 'opacity 0.15s ease';
      img.style.opacity = '0';
    });
    
    // Después de la transición, reemplazar
    setTimeout(function() {
      existingImages.forEach(img => img.remove());
      
      const mediaDiv = wrapper.querySelector('.product-card__media') || wrapper;
      mediaDiv.insertBefore(imageContainer, mediaDiv.firstChild);
      
      // Fade in rápido de las nuevas imágenes
      images[0].style.transition = 'opacity 0.15s ease';
      setTimeout(function() {
        images[0].style.opacity = '1';
      }, 20);
    }, 150);
    
    // Crear flechas
    const arrowsContainer = document.createElement('div');
    arrowsContainer.className = 'product-card-arrows';
    
    const prevArrow = document.createElement('button');
    prevArrow.className = 'product-card-arrow product-card-arrow--prev';
    prevArrow.innerHTML = '‹';
    prevArrow.type = 'button';
    
    const nextArrow = document.createElement('button');
    nextArrow.className = 'product-card-arrow product-card-arrow--next';
    nextArrow.innerHTML = '›';
    nextArrow.type = 'button';
    
    arrowsContainer.appendChild(prevArrow);
    arrowsContainer.appendChild(nextArrow);
    wrapper.appendChild(arrowsContainer);
    
    // Crear indicadores de puntos (dots) para móvil
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'product-card-dots';
    
    images.forEach(function(img, i) {
      const dot = document.createElement('button');
      dot.className = 'product-card-dot';
      if (i === 0) dot.classList.add('active');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Ir a imagen ' + (i + 1));
      
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        currentIndex = i;
        updateImages();
        updateDots();
      });
      
      dotsContainer.appendChild(dot);
    });
    
    wrapper.appendChild(dotsContainer);
    
    function updateImages() {
      images.forEach(function(img, i) {
        if (i === currentIndex) {
          img.style.setProperty('opacity', '1', 'important');
          img.style.setProperty('visibility', 'visible', 'important');
          img.style.setProperty('z-index', '2', 'important');
        } else {
          img.style.setProperty('opacity', '0', 'important');
          img.style.setProperty('visibility', 'hidden', 'important');
          img.style.setProperty('z-index', '1', 'important');
        }
      });
    }
    
    function updateDots() {
      const dots = dotsContainer.querySelectorAll('.product-card-dot');
      dots.forEach(function(dot, i) {
        if (i === currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }
    
    prevArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = currentIndex <= 0 ? images.length - 1 : currentIndex - 1;
      updateImages();
      updateDots();
    });
    
    nextArrow.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      currentIndex = currentIndex >= images.length - 1 ? 0 : currentIndex + 1;
      updateImages();
      updateDots();
    });
    
    card.addEventListener('mouseenter', function() {
      arrowsContainer.style.opacity = '1';
    });
    
    card.addEventListener('mouseleave', function() {
      arrowsContainer.style.opacity = '0';
      setTimeout(function() {
        currentIndex = 0;
        updateImages();
        updateDots();
      }, 100); // Reducido de 300ms a 100ms
    });
    
    // SWIPE para móvil
    let touchStartX = 0;
    let touchEndX = 0;
    let touchStartY = 0;
    let touchEndY = 0;
    
    imageContainer.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    imageContainer.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      handleSwipe();
    }, { passive: true });
    
    function handleSwipe() {
      const swipeThreshold = 50; // Mínimo 50px para considerar swipe
      const diffX = touchStartX - touchEndX;
      const diffY = Math.abs(touchStartY - touchEndY);
      
      // Solo swipe horizontal (no vertical scroll)
      if (Math.abs(diffX) > swipeThreshold && diffY < 100) {
        if (diffX > 0) {
          // Swipe izquierda - siguiente imagen
          currentIndex = currentIndex >= images.length - 1 ? 0 : currentIndex + 1;
          updateImages();
          updateDots();
        } else {
          // Swipe derecha - imagen anterior
          currentIndex = currentIndex <= 0 ? images.length - 1 : currentIndex - 1;
          updateImages();
          updateDots();
        }
      }
    }
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initCarousel, 800); // Reducido de 1500ms a 800ms
    });
  } else {
    setTimeout(initCarousel, 800);
  }
  
  if (typeof window.Shopify !== 'undefined') {
    document.addEventListener('shopify:section:load', function() {
      setTimeout(initCarousel, 1000);
    });
  }
})();